export default "__VITE_ASSET__BoDgtx76__"